import { atomWithReset } from "jotai/utils";

export const artistOnboardingSurveyFormModalAtom = atomWithReset(false);
artistOnboardingSurveyFormModalAtom.debugLabel =
  "Display Artist Onboarding Survey Form Modal";
